'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsonpathPlus = require('./jsonpath-plus.js');



exports.jsonPathPlus = jsonpathPlus['default'];
